import { FinancialServicesUIIntlProvider } from '@shipstation/client-common/components/financial-services-ui-intl-provider';

import { useFsuiContext } from './fsui-context-provider';
import { useLocale } from '../intl/hooks';

/**
 * @param {object} params
 * @param {React.ReactNode} params.children
 * @param {import('@shipstation/financial-services-ui-components').BillingInfoData} [params.initialBillingInfo]
 * @param {(billingInfo?: import('@shipstation/financial-services-ui-components').BillingInfoData) => void} [params.onBillingInfoUpdate]
 * @returns {JSX.Element}
 */
export const FinancialServicesUIProviderWrapper = ({ children, initialBillingInfo, onBillingInfoUpdate }) => {
  const { preloadedSession: initialSession, apiConfig } = useFsuiContext();
  const { locale } = useLocale();

  return (
    <FinancialServicesUIIntlProvider
      apiConfig={apiConfig}
      billingInfo={initialBillingInfo}
      initialSession={initialSession}
      locale={locale}
      onBillingInfoUpdate={onBillingInfoUpdate}
      useMantine
    >
      {children}
    </FinancialServicesUIIntlProvider>
  );
};
